/**
 * Khối 最短お届け日時 của `/pages/delivery-top`: `#prefSel` và `#zip1_kj`/`#zip2_kj` gọi
 * `/delivery-estimate?mode=member`, render vào `#arrival_kj` theo `common/arrival_date.tpl.php`.
 * Port `zip2Addr.js` kind=3 (`estFromPref:293-323`, `startEstDate`/`estCheck:183-291`).
 * Body page migrate không còn handler inline nên script nhúng từ `fixed-page-content.liquid`.
 */
(function () {
  'use strict';

  const RESULT_ID = 'arrival_kj';

  /** 全角数字 → 半角 rồi ghi lại vào ô nhập (zip2Addr.js:7-10) */
  function normalizeZipInput(input) {
    if (!input) return '';
    const v = (input.value || '').replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xfee0));
    input.value = v;
    return v.replace(/[^0-9]/g, '');
  }

  function truckSrc() {
    const tag = document.querySelector('script[data-ink-delivery-truck]');
    return (tag && tag.getAttribute('data-truck-src')) || '';
  }

  /** span.c01.f28fx = đỏ + 28px (common-pruned.css) */
  function accent(text) {
    const span = document.createElement('span');
    span.className = 'c01 f28fx';
    span.textContent = text;
    return span;
  }

  /** 締切 = `endTime.hour`+時 (arrival_date.tpl.php:6); cutoff lẻ phút thì kèm 分. */
  function cutoffText(est) {
    const end = est.end_time;
    if (!end || !end.hour) return '';
    const label = est.last_ship_label || '';
    const min = String(end.min || '00');
    return label + end.hour + '時' + (min === '00' ? '' : min + '分');
  }

  /** 1:1 common/arrival_date.tpl.php */
  function buildResult(d) {
    const est = d.estimate || {};
    const fast = est.fast_day || {};

    const box = document.createElement('div');
    box.className = 'meyasuResultBox mb80';

    const img = document.createElement('img');
    img.src = truckSrc();
    img.alt = 'トラック';
    img.loading = 'lazy';
    box.appendChild(img);

    const body = document.createElement('div');
    body.className = 'pt5';

    const place = document.createElement('span');
    place.className = 'fb';
    place.textContent = (d.pref_name || '') + (d.address || '');
    body.appendChild(place);
    body.appendChild(document.createTextNode('には'));

    // endTime rỗng → bỏ hẳn dòng, tránh in「本日時」
    const cutoff = cutoffText(est);
    if (cutoff) {
      const line = document.createElement('div');
      line.className = 'mt5';
      line.appendChild(accent(cutoff));
      line.appendChild(document.createTextNode('までのご注文を'));
      body.appendChild(line);
    }

    if (est.today_shipping_flg) {
      body.appendChild(accent((est.deliver_label || '') + '（' + (fast.wday || '') + '）'));
    } else {
      body.appendChild(accent(fast.year + '年' + fast.month + '月' + fast.day + '日'));
      body.appendChild(accent(est.fast_time || ''));
    }
    body.appendChild(document.createTextNode('にお届け可能です。'));

    box.appendChild(body);
    return box;
  }

  function render(d) {
    const target = document.getElementById(RESULT_ID);
    if (!target || !d || !d.estimate) return;
    target.textContent = '';
    target.appendChild(buildResult(d));
  }

  async function estimate(api, params) {
    window.inkProcessing?.show();
    try {
      const res = await api.get('/delivery-estimate', params);
      render(res && res.data);
    } catch (err) {
      // Tra hụt thì giữ nguyên khối kết quả (zip2Addr.js không có nhánh lỗi)
      console.warn('[delivery-top] delivery estimate failed', err);
    } finally {
      window.inkProcessing?.hide();
    }
  }

  /** option 0 = 都道府県を選択 → không tra (estFromPref, zip2Addr.js:293-323) */
  function bindPrefSelect(api) {
    const sel = document.getElementById('prefSel');
    if (!sel) return;
    sel.addEventListener('change', () => {
      const prefCd = parseInt(sel.value, 10);
      if (!prefCd) return;
      estimate(api, { mode: 'member', pref_cd: prefCd });
    });
  }

  /**
   * Gõ đủ 3+4 số là tra ngay, không nút bấm (startEstDate/estCheck zip2Addr.js:183-291).
   * Debounce + khoá zip vừa tra thay cho vòng poll AjaxZip3 500ms×10.
   */
  function bindZipInputs(api) {
    const zip1El = document.getElementById('zip1_kj');
    const zip2El = document.getElementById('zip2_kj');
    if (!zip1El || !zip2El) return;

    let timer = 0;
    let inFlight = false;
    let lastZip = '';

    // AjaxZip3 ghi kết quả vào 4 hidden field này — giữ parity DOM
    function setHidden(id, value) {
      const el = document.getElementById(id);
      if (el) el.value = value || '';
    }

    async function lookup() {
      const zip1 = normalizeZipInput(zip1El);
      const zip2 = normalizeZipInput(zip2El);
      if (zip1.length !== 3 || zip2.length !== 4) return;

      const zip = zip1 + zip2;
      if (inFlight || zip === lastZip) return;
      inFlight = true;
      window.inkProcessing?.show();
      try {
        const zipRes = await api.get('/zip/' + zip);
        const addr = zipRes && zipRes.data;
        if (!addr || !addr.pref_name) return;

        lastZip = zip;
        setHidden('pref_kj', addr.pref_name);
        setHidden('city_kj', addr.city);
        setHidden('town_kj', addr.town);
        setHidden('prefCd_kj', addr.pref_cd);

        // address = city + town (zip2Addr.js:271)
        const params = {
          mode: 'member',
          pref_name: addr.pref_name,
          address: (addr.city || '') + (addr.town || ''),
        };
        if (addr.pref_cd) params.pref_cd = addr.pref_cd;

        const res = await api.get('/delivery-estimate', params);
        render(res && res.data);
      } catch (err) {
        console.warn('[delivery-top] zip search failed', err);
      } finally {
        inFlight = false;
        window.inkProcessing?.hide();
      }
    }

    [zip1El, zip2El].forEach((el) => {
      el.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(lookup, 300);
      });
    });
  }

  function run(api) {
    if (!document.getElementById(RESULT_ID)) return;
    bindPrefSelect(api);
    bindZipInputs(api);
  }

  if (window.inkApi) {
    run(window.inkApi);
  } else {
    document.addEventListener('ink:api:ready', () => run(window.inkApi), { once: true });
  }
})();
